/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */

import { Box, Button, Dialog, DialogActions, FormControl, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import { Typography, withStyles } from '@material-ui/core';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import React, { useEffect, useState } from 'react';

import FullscreenSpinner from 'modules/common/fullscreenSpinner.component';

import { setPageTitle, showToast } from 'modules/layout/layout.actions';
import { ZERO_GUID } from 'modules/enumerations/enumerationIds';
import { getEmailTemplate, getEmailTemplateSummaries, getEmailTemplateTokens, postEmailTemplate, putEmailTemplate } from 'modules/emailTemplates/store/emailTemplate.actions';
import { fetchEnumerations } from 'modules/authorizations/utils/fetchDataDetailsService';
import {
  getAllCountries,
  getAllCurrencies,
  getAllEnumerations,
  getAllProvinces,
  getAllSaleTypes,
  getAllWeightTypes
} from 'modules/enumerations/store/enumerationActions';
import AdminEmailTemplateGridComponent from './adminEmailTemplateGrid.component';
import SpinnerComponent from 'modules/common/spinner.component';
import { Permissions } from 'modules/layout/permissions';
import { hasPermission } from 'modules/layout/permissionService';
import {
  GET_EMAIL_TEMPLATE_FAILURE,
  GET_EMAIL_TEMPLATES_SUMMARIES_FAILURE,
  PUT_EMAIL_TEMPLATE_FAILURE
} from 'modules/emailTemplates/store/emailTemplateTypes';

const styles = theme => ({
  wideControl: {
    minWidth: 174
  },
  section: {
    marginBottom: theme.spacing(2)
  },
  selfServicePolicySelect: {
    minWidth: 300
  }
});

export const defaultTemplate = () => {
  return {
    templateId: 0,
    templateName: '',
    subjectTemplate: '',
    bodyHtmlTemplate: '',
    serviceId: ZERO_GUID,
    regardingId: ZERO_GUID,
    isServiceGeneralTemplate: true,
    isSingleRequest: false,
    isApiRequest: false,
    apiRequestTypeId: ZERO_GUID,
    apiRequestUrl: ''
  };
};

export const createFilteredRegardingOptions = (template, authCommentRegardingTypes) => (template?.serviceId && template?.serviceId !== '00000000-0000-0000-0000-000000000000' ? authCommentRegardingTypes.filter(
  option => {
    // Handle DSP cases for dest or global
    if (template?.serviceId === '946f7f77-2a35-4d86-9b18-616f927f7124' || template?.serviceId === '7d4d3d04-66b8-4d44-9131-5c7b2cf8b1f6') {
      if (option.additionalField === template?.serviceId || option.additionalField === '11111111-1111-1111-1111-111111111111')
        return option;
    }
    else {
      if (option.additionalField === template?.serviceId || (option.additionalField === '11111111-1111-1111-1111-111111111111' && option.title !== 'DSP'))
        return option;
    }
  }).sort((a, b) =>
    a.title.localeCompare(b.title)) : []);

const AdminEmailTemplateView = props => {
  const { history, enumerations } = props;
  const [isLoading, setIsLoading] = useState(false);
  const [template, setTemplate] = useState(defaultTemplate());
  const [showCreateTemplate, setShowCreateTemplate] = useState(false);
  const [isLoadingModal, setIsLoadingModal] = useState(false);

  const allEnums = enumerations?.allEnums || {};

  const authCommentServiceTypes = enumerations?.allEnums?.authCommentService ? enumerations.allEnums.authCommentService.filter(s => s.enumType === 1).sort((a, b) => 
      a.title.localeCompare(b.title)
    ) : [];

  const authCommentRegardingTypes =
    allEnums.authCommentRegarding && allEnums.authCommentRegarding.length > 0
      ? allEnums.authCommentRegarding.filter(s => s.isActive === true)
      : [{ id: ZERO_GUID, title: '' }];


    const [filteredRegardingOptions, setFilteredRegardingOptions] = useState(createFilteredRegardingOptions(template, authCommentRegardingTypes));

  // const apiRequestTypes =
  //   allEnums.apiRequestTypes && allEnums.apiRequestTypes.length > 0
  //     ? allEnums.apiRequestTypes.filter(s => s.isActive === true)
  //     : [{ id: ZERO_GUID, title: '' }];

  useEffect(() => {
    props.setPageTitle('Templates');
    async function fetchData() {
      setIsLoading(true);
      try {
        await fetchEnumerations(props);
        if (!props.templates || props.templates.areTokenLoaded === false) {
          await props.getEmailTemplateTokens();
        }
        if (!props.templates || props.templates.isLoaded === false) {
          await props.getEmailTemplateSummaries();
        }
      } catch (error) {
      } finally {
        setIsLoading(false);
        setFilteredRegardingOptions(createFilteredRegardingOptions(template, authCommentRegardingTypes));
      }
    }
    fetchData();
  }, []);

  const createTemplate = async () => {
    setIsLoadingModal(true);
    try {
      const response = await props.postEmailTemplate(template);
      await props.getEmailTemplateSummaries();
      props.showToast('Template created successfully', 'success');
      history.push(`/templates/${response.response.templateId}`);
      return response.response;
    } catch (error) {
      props.showToast('Error creating template', 'error');
      return null;
    } finally {
      setIsLoadingModal(false);
    }
  };

  const canReadTemplates = hasPermission(Permissions.Admin.Templates.Read);
  const canEditTemplates = hasPermission(Permissions.Admin.Templates.Edit);

  if (!canReadTemplates) {
    history.push('/');
    return null;
  }
  
  const hideTemplate = async templateId => {
    try {
      const templateResponse = await props.getEmailTemplate(templateId);
      if (templateResponse.type === GET_EMAIL_TEMPLATE_FAILURE || !templateResponse.response) {
        throw new Error('Failed to load template.');
      }

      const updateResponse = await props.putEmailTemplate(templateId, { ...templateResponse.response, showTemplate: false });
      if (updateResponse.type === PUT_EMAIL_TEMPLATE_FAILURE) {
        throw new Error('Failed to hide template.');
      }

      const summariesResponse = await props.getEmailTemplateSummaries();
      if (summariesResponse.type === GET_EMAIL_TEMPLATES_SUMMARIES_FAILURE) {
        throw new Error('Failed to refresh templates.');
      }

      props.showToast('Template hidden successfully', 'success');
    } catch (error) {
      props.showToast('Error hiding template', 'error');
    }
  };

  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center',
          px: '20px',
          mt: 4,
          mb: 2
        }}
      >
        <Button
          color="secondary"
          variant="contained"
          sx={{
            maxHeight: '40px',
            backgroundColor: '#5D9878',
            '&:hover': { backgroundColor: '#528569' },
            mr: 4
          }}
          onClick={() => {
            setTemplate(defaultTemplate());
            setShowCreateTemplate(true);
          }}
                    disabled={!canEditTemplates}
        >
          Create Template
        </Button>
      </Box>

      {isLoading && <FullscreenSpinner />}

      {!isLoading && props.templates && props.enumerations.allEnums && (
        <AdminEmailTemplateGridComponent
          classes={props.classes}
          enumerations={props.enumerations ? props.enumerations.allEnums : []}
          emailTemplates={props.templates ? props.templates.emailTemplates : []}
          history={history}
          hideTemplate={hideTemplate}
        />
      )}

      <Dialog
        open={showCreateTemplate}
        fullWidth
        maxWidth="md"
        PaperProps={{
          sx: {
            minWidth: '500px',
            paddingBottom: '10px'
          }
        }}
      >
        <Box sx={{ p: '25px' }}>
          <Typography variant="h5">New Template</Typography>
        </Box>

        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            p: '10px 25px',
            gap: 6,
            alignItems: 'flex-start'
          }}
        >
          <Box sx={{ minWidth: '240px' }}>
            <Typography variant="subtitle1">Template Name</Typography>
            <TextField
              required
              value={template.templateName}
              onChange={e => setTemplate({ ...template, templateName: e.target.value })}
              variant="outlined"
              size="small"
              fullWidth
            />
            <Typography variant="caption" display="block" color="primary">
              Required
            </Typography>
          </Box>

          <FormControl sx={{ minWidth: '240px', mt: '6px' }}>
            <InputLabel sx={{ marginLeft: '-15px', marginTop: '7px' }} id="new-template-service-label">
              Service (optional)
            </InputLabel>
            <Select
              labelId="new-template-service-label"
              label="Service (optional)"
              variant="standard"
              sx={{
                marginTop: '6px',
                marginBottom: '6px',
                maxWidth: '360px',
                minWidth: '240px'
              }}
              value={template.serviceId || ZERO_GUID}
              onChange={e => {
                setTemplate({ ...template, serviceId: e.target.value });
                setFilteredRegardingOptions(createFilteredRegardingOptions({ ...template, serviceId: e.target.value }, authCommentRegardingTypes));
              }}
            >
              {authCommentServiceTypes.length > 0 ? (
                authCommentServiceTypes.map(opt => (
                  <MenuItem key={opt.id} value={opt.id} sx={{ margin: 'dense' }}>
                    {opt.title}
                  </MenuItem>
                ))
              ) : (
                <MenuItem sx={{ margin: 'dense' }}>{'No options available'}</MenuItem>
              )}
            </Select>
          </FormControl>
          <FormControl sx={{ minWidth: '240px', mt: '6px' }}>
            <InputLabel sx={{ marginLeft: '-15px', marginTop: '7px' }} id="new-template-regarding-label">
              Regarding (optional)
            </InputLabel>
            <Select
              labelId="new-template-regarding-label"
              label="Regarding (optional)"
              variant="standard"
              sx={{
                marginTop: '6px',
                marginBottom: '6px',
                maxWidth: '360px',
                minWidth: '240px'
              }}
              value={template.regardingId || ZERO_GUID}
              onChange={e => setTemplate({ ...template, regardingId: e.target.value })}
            >
              {filteredRegardingOptions.length > 0 ? (
                filteredRegardingOptions.map(opt => (
                  <MenuItem key={opt.id} value={opt.id} sx={{ margin: 'dense' }}>
                    {opt.title}
                  </MenuItem>
                ))
              ) : (
                <MenuItem sx={{ margin: 'dense' }}>{'No options available'}</MenuItem>
              )}
            </Select>
          </FormControl>
        </Box>

        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            p: '10px 25px',
            gap: 6, 
            alignItems: 'flex-start'
          }}
        >
          {/*<Box>
            <FormControlLabel
              control={
                <Switch
                  checked={template.isApiRequest}
                  onChange={e => setTemplate({ ...template, isApiRequest: e.target.checked })}
                  color="primary"
                />
              }
              label="Is API Request"
            />
          </Box>
           {template.isApiRequest && (
            <>
              <FormControl sx={{ minWidth: '240px', mt: '6px' }}>
                <InputLabel sx={{ marginLeft: '-15px', marginTop: '7px' }} id="new-template-regarding-label">
                  API Request Type
                </InputLabel>
                <Select
                  labelId="new-template-regarding-label"
                  label="API Request Type"
                  variant="standard"
                  sx={{
                    marginTop: '6px',
                    marginBottom: '6px',
                    maxWidth: '360px',
                    minWidth: '240px'
                  }}
                  value={template.apiRequestTypeId || ZERO_GUID}
                  onChange={e => setTemplate({ ...template, apiRequestTypeId: e.target.value })}
                >
                  {apiRequestTypes.length > 0 ? (
                    apiRequestTypes.map(opt => (
                      <MenuItem key={opt.id} value={opt.id} sx={{ margin: 'dense' }}>
                        {opt.title}
                      </MenuItem>
                    ))
                  ) : (
                    <MenuItem sx={{ margin: 'dense' }}>{'No options available'}</MenuItem>
                  )}
                </Select>
              </FormControl>
              <Box sx={{ minWidth: '240px' }}>
                <Typography variant="subtitle1">API Request URL</Typography>
                <TextField
                  required={false}
                  value={template.apiRequestUrl}
                  onChange={e => setTemplate({ ...template, apiRequestUrl: e.target.value })}
                  variant="outlined"
                  size="small"
                  fullWidth
                />
              </Box>
            </>
          )} */}
          
        </Box>

        <DialogActions sx={{ p: '1.25rem' }}>
          {isLoadingModal && <SpinnerComponent />}
          {!isLoadingModal && (
            <>
              <Button onClick={() => setShowCreateTemplate(false)} sx={{ color: '#41B7C0', '&:hover': { color: '#3d959c' } }}>
                Cancel
              </Button>
              <Button
                onClick={createTemplate}
                color="primary"
                sx={{ backgroundColor: '#41B7C0', '&:hover': { backgroundColor: '#3d959c' } }}
                type="submit"
                variant="contained"
                disabled={!canEditTemplates || template.templateName == null || template.templateName.trim() === ''}
              >
                Create Template
              </Button>
            </>
          )}
        </DialogActions>
      </Dialog>
    </Box>
  );
};

const mapStateToProps = state => {
  const enumerations = state.enumerations;
  const templates = state.templates;
  return {
    enumerations,
    templates
  };
};

export default compose(
  withStyles(styles),
  connect(mapStateToProps, {
    showToast,
    getAllEnumerations,
    getAllSaleTypes,
    getAllWeightTypes,
    getAllProvinces,
    getAllCurrencies,
    getAllCountries,
    getEmailTemplateSummaries,
    getEmailTemplate,
    putEmailTemplate,
    postEmailTemplate,
    setPageTitle,
    getEmailTemplateTokens
  })
)(AdminEmailTemplateView);
